import React from "react";
import {
  faCalendarCheck,
  faChampagneGlasses,
  faCogs,
  faLocationDot,
  faPercent,
  faBuildingUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import RequestQuoteRoundedIcon from "@mui/icons-material/RequestQuoteRounded";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { getRuta } from "../../helpers/Helpers";
import NavItem from "./NavItem";
import { sidebar } from "../../theme";

export const Configurations = ({ drawerIsOpen }) => {
  const [open, setOpen] = React.useState(false);
  let rout = getRuta();
  return (
    <div>
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "13px",
          padding: "11px 12px",
          borderRadius: "11px",
          cursor: "pointer",
          color: sidebar.itemColor,
          "&:hover": { backgroundColor: "rgba(255,255,255,.06)", color: sidebar.userColor },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: 19, color: "inherit", flexShrink: 0 }}>
          <FontAwesomeIcon icon={faCogs} fontSize="inherit" />
        </Box>
        <Typography sx={{ fontSize: 14.5, flex: 1, minWidth: 0 }}>Configuraciones</Typography>
        {open ? <ExpandLessRoundedIcon sx={{ fontSize: 18 }} /> : <ExpandMoreRoundedIcon sx={{ fontSize: 18 }} />}
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Stack marginTop={0.3} paddingLeft={drawerIsOpen ? 2 : 0} spacing={0.3}>
          <NavItem to={`${rout}/sucursales`} sub icon={<FontAwesomeIcon icon={faBuildingUser} fontSize="inherit" />} label="Sucursales" />
          <NavItem to={`${rout}/locations`} sub icon={<FontAwesomeIcon icon={faLocationDot} fontSize="inherit" />} label="Ubicaciones" />
          <NavItem to={`${rout}/tasa-interes`} sub icon={<FontAwesomeIcon icon={faPercent} fontSize="inherit" />} label="Tasa de Interés" />
          <NavItem to={`${rout}/periodicidad`} sub icon={<FontAwesomeIcon icon={faCalendarCheck} fontSize="inherit" />} label="Periodicidad" />
          <NavItem to={`${rout}/holidays`} sub icon={<FontAwesomeIcon icon={faChampagneGlasses} fontSize="inherit" />} label="Días Festivos" />
          <NavItem to={`${rout}/conceptogastos`} sub icon={<RequestQuoteRoundedIcon fontSize="inherit" />} label="Concepto Gastos" />
          <NavItem to={`${rout}/tasa-cambio`} sub icon={<CurrencyExchangeIcon fontSize="inherit" />} label="Tasa de Cambio" />
        </Stack>
      </Collapse>
    </div>
  );
};
